import React, { useContext, useEffect, useState } from 'react'
import { ADMINTAB, ASSISTANTADMINTAB, MOBILEADMINTAB, adminCasesPanelItems, getAdminAwaitCountApi } from '../../Constants';
import Template from 'Components/Templates/Template';
import AdminPanelRedirect from './AdminPanelRedirect';
import { Context } from 'Context/Context';
import Header from 'Components/Header/Header';
import useIsMobile from 'Hooks/useIsMobile';
import { Menu } from 'lucide-react';
import SidePanelMobile, { SidePanelItem, MobileSectionBar } from 'Components/Professional/Cases/SidePanelMobile';

function AdminPage() {
  const [activePanel, setActivePanel] = useState(0);
  const isMobile = useIsMobile()
  const {userDetails, awaitCount, setAwaitCount, setSelectedMenuItem, makeApiCallFunc} = useContext(Context);
  const [tabItems, setTabItems] = useState([]);
  const [openMenu, setOpenMenu] = useState(false);

  const [activeTab, setActiveTab] = useState(userDetails.isAdminAssistant ? "1" : "2");
  useEffect(() => {
    makeApiCallFunc(getAdminAwaitCountApi, null, ({data}) => {
      setAwaitCount(data.awaits);
    }, (data) => console.log(data))
  },[])
  useEffect(() => {
    setSelectedMenuItem(userDetails.isAdminAssistant ? 1: 2)
    if(userDetails.isAdminAssistant)
    {
      ASSISTANTADMINTAB[0].count = awaitCount?.validUserIdCount;
      adminCasesPanelItems[0].count = awaitCount?.verify;
      adminCasesPanelItems[1].count = awaitCount?.update;
      adminCasesPanelItems[2].count = awaitCount?.firm;
    }
    else 
    {
      ADMINTAB.find((t) => t.menuName === "approve").count = awaitCount?.validUserIdCount;
      adminCasesPanelItems[0].count = awaitCount?.verify;
      adminCasesPanelItems[1].count = awaitCount?.update;
      adminCasesPanelItems[2].count = awaitCount?.firm;
    }
    setTabItems(userDetails.isAdminAssistant ? ASSISTANTADMINTAB : (isMobile ? MOBILEADMINTAB : ADMINTAB));
  },[activePanel, userDetails, awaitCount])
    return (
      <>
        <Header />  
        {isMobile &&
          <SidePanelMobile
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            eyebrow='Admin'
            title='Approvals'
            content={adminCasesPanelItems.map((item) => (
              <SidePanelItem key={item.key} active={activePanel === item.key}
                onClick={() => { setActivePanel(item.key); setOpenMenu(false); }}>
                {item.menu}
              </SidePanelItem>
            ))}
          />}
        {isMobile &&
          <MobileSectionBar
            eyebrow='Awaiting approval'
            title={adminCasesPanelItems.find((item) => item.key === activePanel)?.menu || 'Approvals'}
            onMenu={() => setOpenMenu(true)}
          />}
      <Template
      activeTab = {activeTab}
      leaveTabs = {true}
      setActiveTab = {setActiveTab}
      tabs= {tabItems}
      panelItems={adminCasesPanelItems}
      activePanel={activePanel}
      leaveLeftPanel={isMobile ? true : false}
      setActivePanel={setActivePanel}
      content = {<AdminPanelRedirect activePanel={activePanel}/>}
      />
     </>
    )
}

export default AdminPage